import { useCallback, useContext } from 'react';

import { TokenContext } from '@/Contexts/TokenContext';

import { baseUrl } from '@/utils/constants';

import { useCustomFetch } from './useCustomFetch';

export default function useApplicationTransaction() {
  const { authResult } = useContext(TokenContext);
  const { customFetch } = useCustomFetch();

  const applicationTransactionUrl = `${baseUrl}applicationtransactions`;

  const requeueApplicationTransaction = useCallback(
    async (applicationTransactionId: number) => {
      const response = await customFetch(`${applicationTransactionUrl}/requeue`, {
        method: 'POST',
        headers: {
          accept: 'application/json',
          'content-type': 'application/json',
          Authorization: `Bearer ${authResult.accessToken}`,
        },
        body: JSON.stringify({ applicationTransactionId }),
      });

      return response;
    },
    [authResult, applicationTransactionUrl, customFetch]
  );

  const cancelApplicationTransaction = useCallback(
    async (applicationTransactionId: number) => {
      const response = await customFetch(`${applicationTransactionUrl}/cancel`, {
        method: 'POST',
        headers: {
          accept: 'application/json',
          'content-type': 'application/json',
          Authorization: `Bearer ${authResult.accessToken}`,
        },
        body: JSON.stringify({ applicationTransactionId }),
      });

      return response;
    },
    [authResult, applicationTransactionUrl, customFetch]
  );

  return {
    requeueApplicationTransaction,
    cancelApplicationTransaction,
  };
}
